export class UserStatusConstant {
  static readonly DELETED = 'deleted';
}
